import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'

import { ReduxState } from '@/utils/typeHelpers'

interface ConversationState {
  yourTurnCount: number
}

const initialState: ConversationState = {
  yourTurnCount: 0,
}

const conversationSlice = createSlice({
  name: 'conversation',
  initialState,
  reducers: {
    updateYourTurnCount: (state, action: PayloadAction<number>) => {
      state.yourTurnCount = action.payload
    },
  },
})

export default conversationSlice.reducer

export const { updateYourTurnCount } = conversationSlice.actions

const selectConversationState = (state: ReduxState) => state.conversations

export const selectYourTurnNumber = createSelector(
  selectConversationState,
  (convoState) => convoState.yourTurnCount
)
